// export the longest animation duration!
import { duration } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import { motion } from "framer-motion";
import Box from "../Box";
export const animationDuration = duration.animation.slow;
const moderate = duration.animation.moderate / 1000;
const slow = duration.animation.slow / 1000;
export const animations = {
    height: {
        init1: {
            height: "0px",
            transition: { duration: moderate },
        },
        enter1: {
            height: "auto",
            transition: { duration: moderate },
        },
        exit1: {
            height: "0px",
            transition: { duration: moderate },
        },
    },
    main: {
        init1: {
            translateY: "-50%",
            transition: { duration: moderate },
        },
        enter1: {
            translateY: "0px",
            transition: { duration: moderate },
        },
        init2: {
            opacity: 0,
            transition: {
                duration: moderate,
            },
        },
        enter2: {
            opacity: 1,
            transition: {
                duration: slow,
            },
        },
        exit1: {
            translateY: "-50%",
            transition: { duration: slow },
        },
        exit2: {
            opacity: 0,
            transition: {
                duration: moderate,
            },
        },
    },
};
export const MainAnimationContainer = motion.create(Box);
export const HeightAnimationContainer = motion.create(Box);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRm9sZERvd25BbmltYXRpb24vY29uZmlnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLHlDQUF5QztBQUN6QyxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDMUUsT0FBTyxFQUFFLE1BQU0sRUFBWSxNQUFNLGVBQWUsQ0FBQztBQUNqRCxPQUFPLEdBQUcsTUFBTSxRQUFRLENBQUM7QUFFekIsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsUUFBUSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUM7QUFDekQsTUFBTSxRQUFRLEdBQUcsUUFBUSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsSUFBSSxDQUFDO0FBQ3BELE1BQU0sSUFBSSxHQUFHLFFBQVEsQ0FBQyxTQUFTLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztBQUM1QyxNQUFNLENBQUMsTUFBTSxVQUFVLEdBQXdDO0lBQzdELE1BQU0sRUFBRTtRQUNOLEtBQUssRUFBRTtZQUNMLE1BQU0sRUFBRSxLQUFLO1lBQ2IsVUFBVSxFQUFFLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRTtTQUNuQztRQUNELE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxNQUFNO1lBQ2QsVUFBVSxFQUFFLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRTtTQUNuQztRQUNELEtBQUssRUFBRTtZQUNMLE1BQU0sRUFBRSxLQUFLO1lBQ2IsVUFBVSxFQUFFLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRTtTQUNuQztLQUNGO0lBQ0QsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFO1lBQ0wsVUFBVSxFQUFFLE1BQU07WUFDbEIsVUFBVSxFQUFFLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRTtTQUNuQztRQUNELE1BQU0sRUFBRTtZQUNOLFVBQVUsRUFBRSxLQUFLO1lBQ2pCLFVBQVUsRUFBRSxFQUFFLFFBQVEsRUFBRSxRQUFRLEVBQUU7U0FDbkM7UUFDRCxLQUFLLEVBQUU7WUFDTCxPQUFPLEVBQUUsQ0FBQztZQUNWLFVBQVUsRUFBRTtnQkFDVixRQUFRLEVBQUUsUUFBUTthQUNuQjtTQUNGO1FBQ0QsTUFBTSxFQUFFO1lBQ04sT0FBTyxFQUFFLENBQUM7WUFDVixVQUFVLEVBQUU7Z0JBQ1YsUUFBUSxFQUFFLElBQUk7YUFDZjtTQUNGO1FBQ0QsS0FBSyxFQUFFO1lBQ0wsVUFBVSxFQUFFLE1BQU07WUFDbEIsVUFBVSxFQUFFLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRTtTQUMvQjtRQUNELEtBQUssRUFBRTtZQUNMLE9BQU8sRUFBRSxDQUFDO1lBQ1YsVUFBVSxFQUFFO2dCQUNWLFFBQVEsRUFBRSxRQUFRO2FBQ25CO1NBQ0Y7S0FDRjtDQUNGLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxzQkFBc0IsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0FBQ3pELE1BQU0sQ0FBQyxNQUFNLHdCQUF3QixHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUMifQ==